"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgBtn = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItem_1 = require("../../ContextItem");
const ContextMenu_1 = require("../../ContextMenu");
const BasicButton_1 = require("../../../../2-inline-block/BasicButton");
const Popup_1 = require("../../../Popup");
const Sidetip_1 = require("../../../../1-inline/Sidetip");
const context_1 = require("../../../../styles/context");
const OptionalBadge_1 = require("./OptionalBadge");
const tintIcon = (icon, color) => {
    if (!React.isValidElement(icon))
        return icon;
    const el = icon;
    return React.cloneElement(el, {
        style: { color, ...(el.props.style ?? {}) },
    });
};
/**
 * Action-button arg. Renders a small `<BasicButton>` on the row's right side
 * that fires `param.onClick` when pressed. Has no value, doesn't appear in
 * the args map.
 */
const ArgBtn = ({ param }) => {
    const [t] = (0, use_t_1.useT)();
    const styles = (0, context_1.useStyles)();
    const label = param.display?.() ?? t(param.name ?? param.id ?? '');
    const buttonLabel = param.buttonLabel ?? param.name ?? param.id ?? '';
    const danger = !!param.danger;
    const errorColor = styles.col.get('error');
    const rawIcon = param.buttonIcon?.();
    const icon = danger ? tintIcon(rawIcon, errorColor) : rawIcon;
    const buttonFace = (React.createElement("span", { style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            color: danger ? errorColor : undefined,
        } },
        icon,
        React.createElement("span", null, t(buttonLabel))));
    const button = param.confirm ? (React.createElement(BasicButton_1.BasicButton, { width: "auto", height: 28, fill: true }, buttonFace)) : (React.createElement(BasicButton_1.BasicButton, { width: "auto", height: 28, fill: true, onClick: (e) => {
            e.stopPropagation();
            param.onClick?.();
        } }, buttonFace));
    const trigger = param.confirm ? (React.createElement(Popup_1.Popup, { renderContext: ({ onEsc }) => (React.createElement(ContextMenu_1.ContextMenu, { inset: true, onEsc: onEsc, menu: {
                name: param.confirmLabel ?? t('Are you sure?'),
                minWidth: 240,
                children: [
                    { name: t('Cancel'), onSelect: () => { } },
                    {
                        name: param.confirmActionLabel ?? t(buttonLabel),
                        onSelect: () => param.onClick?.(),
                        danger,
                        right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, t('Confirm')),
                    },
                ],
            } })) }, button)) : (button);
    return (React.createElement(ContextItem_1.ContextItem, { icon: param.icon?.(), control: true, inset: true, style: { paddingTop: 6, paddingBottom: 6 }, right: React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', margin: '-5px -8px -5px 0' } }, trigger) },
        React.createElement("span", { style: danger ? { color: errorColor } : undefined },
            label,
            param.optional && React.createElement(OptionalBadge_1.OptionalBadge, null))));
};
exports.ArgBtn = ArgBtn;
